<template>
  <IQOS :title="$t('reserve.max_guests.title')">
    <div>
      <p
        class="comment c-grey"
      >{{$t('reserve.max_guests.input')}}</p>
      <BaseInput class="price-input" :value="`${max_guests_count}`" v-if="!editing" />
      <BaseInput class="price-input" type="number" v-model.number="max_guests_count" :readonly="false" v-if="editing" />
    </div>
    <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS";
import IQOSActions from "@/components/IQOSActions";

import BlackInput from "@/components/BlackInput.vue";

export default {
  data() {
    return {
      editing: false,

      max_guests_count: 6
    };
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.resetValues();
    },
    onEditFinish() {
      if (this.max_guests_count < 1 || this.max_guests_count > 300) return;

      this.$store.commit('setReserveMaxGuests', this.max_guests_count);
      this.$store.dispatch("saveCafe");

      this.editing = false;
    },
    resetValues() {
      if (this.cafe.reserve) {
        this.max_guests_count = this.cafe.reserve.max_guests_count || 6;
      }
    }
  },
  mounted() {
    this.resetValues();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    }
  },
  components: {
    IQOS,
    IQOSActions,
    BlackInput
  }
};
</script>

<style scoped>
.price-input {
  width: 100%;
  margin-top: 1vh;
}
</style>